import OrganicShape from "../Board/OrganicShape";

/**
 * Governance tab hero — active tab icon uses brand dark blue (#09366b) matching OpenBusinessTabs.
 */
const TabHeroCard = ({ title, icon, headline, description, subdescription }) => {
  return (
    <div className="flex flex-col lg:flex-row items-start gap-8 mb-8">
      <div className="flex flex-col items-center gap-4 lg:w-1/6 min-w-[140px]">
        <OrganicShape className="p-6 flex flex-col items-center gap-3 h-48 w-full">
          <h1 className="text-xl font-semibold text-foreground tracking-wide text-center">
            {title}
          </h1>
          <div className="w-12 h-20 rounded-lg bg-[#09366b] flex items-center justify-center text-white shadow-md">
            {icon}
          </div>
        </OrganicShape>
      </div>

      <OrganicShape
        variant="secondary"
        className="flex-1 p-6 bg-gradient-hero min-h-56"
      >
        <div className="space-y-4 h-full flex flex-col justify-center">
          <h2 className="text-xl font-semibold text-foreground mb-2">{headline}</h2>
          <div className="space-y-3">
            <p className="text-sm text-foreground/90 leading-relaxed">{description}</p>
            {subdescription && (
              <p className="text-sm text-foreground/80 leading-relaxed">{subdescription}</p>
            )}
          </div>
        </div>
      </OrganicShape>
    </div>
  );
};

export default TabHeroCard;
